module.exports = __webpack_public_path__ + "static/employee_jbs-a78173573afa97ddc5ef7a712140faf4.jpg";